import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{#if this.mfaIsEnabled}}\n  <Page::Settings::Security::MfaStatus::MfaEnabled />\n{{else}}\n  <Page::Settings::Security::MfaStatus::MfaDisabled />\n{{/if}}")